module.exports = __webpack_public_path__ + "img/help-ot6.044d2bd1.png";